import * as React from 'react';
import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  InputBase,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from '@mui/material';
import { withStyles } from '@material-ui/core/styles';
import { styled } from '@mui/system';
import { Formik } from 'formik';
import { loginSchema } from '../../../../schemas/auth.request';
import { useLoginMutation } from '../../../../store/api/authApi';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../../../store/auth/authSlice';
import GoogleLoginBtn from '../GoogleLoginBtn/GoogleLoginBtn';

const SignInInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '420px',
  height: '510px',
  marginTop: '-6px',
  marginRight: '-7px',
  background: 'rgba(0, 0, 0, 0.5)',

  [theme.breakpoints.down('md')]: {
    width: '400px',
    background: 'transparent',
    marginTop: '0px',
    marginRight: '0px',
  },

  [theme.breakpoints.down('400')]: {
    width: '340px',
    height: '450px',
    background: 'transparent',
    marginTop: '0px',
    marginRight: '0px',
  },
}));

const RegisterRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginTop: '34px',
  paddingRight: '60px',

  [theme.breakpoints.down('md')]: {
    paddingRight: '30px',
    marginTop: '20px',
  },

  [theme.breakpoints.down('400')]: {
    paddingRight: '10px',
    marginTop: '20px',
  },

  [theme.breakpoints.down('350')]: {
    paddingRight: '10px',
    marginTop: '15px',
  },
}));

const RegisterTypography = styled(Typography)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'rgba(255, 255, 255, 0.7)',
  fontFamily: 'Raleway',
  fontSize: '14px',
  lineHeight: '16px',

  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
    lineHeight: '14px',
  },

  [theme.breakpoints.down('400')]: {
    fontSize: '12px',
    lineHeight: '14px',
  },

  [theme.breakpoints.down('350')]: {
    fontSize: '10px',
    lineHeight: '12px',
  },
}));

const RegisterButton = styled(Button)(({ theme }) => ({
  marginLeft: '20px',
  textTransform: 'none',
  color: '#FFFFFF',
  fontFamily: 'Fjalla One',
  backgroundColor: '#000000',
  fontSize: '14px',
  lineHeight: '18px',

  [theme.breakpoints.down('md')]: {
    fontSize: '13px',
    lineHeight: '15px',
  },

  [theme.breakpoints.down('400')]: {
    fontSize: '13px',
    lineHeight: '15px',
  },

  [theme.breakpoints.down('350')]: {
    fontSize: '12px',
    lineHeight: '14px',
    marginLeft: '15px',
  },
}));

const WelcomeTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '46px',
  marginTop: '25px',
  color: '#FFFFFF',
  fontFamily: 'Fjalla One',
  fontSize: '20px',
  lineHeight: '25px',

  [theme.breakpoints.down('md')]: {
    //-10px
    marginLeft: '35px',
    marginTop: '25px',
    fontSize: '22px',
    lineHeight: '27px',
  },

  [theme.breakpoints.down('400')]: {
    //-10px
    marginLeft: '35px',
    marginTop: '25px',
    fontSize: '22px',
    lineHeight: '27px',
  },

  [theme.breakpoints.down('350')]: {
    marginLeft: '30px',
    marginTop: '20px',
    marginBottom: '15px',
    fontSize: '18px',
    lineHeight: '20px',
  },
}));

const WelcomeSubtitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '46px',
  marginTop: '6px',
  color: 'rgba(255, 255, 255, 0.7)',
  fontFamily: 'Raleway',
  fontSize: '13px',
  lineHeight: '14px',

  [theme.breakpoints.down('md')]: {
    marginLeft: '35px',
    marginBottom: '5px',
    marginTop: '5px',
  },

  [theme.breakpoints.down('400')]: {
    marginLeft: '35px',
    marginTop: '5px',
    fontSize: '12px',
    lineHeight: '14px',
  },

  [theme.breakpoints.down('350')]: {
    [theme.breakpoints.down('350')]: {
      marginLeft: '0px',
      marginTop: '0px',
      fontSize: '0px',
      lineHeight: '0px',
    },
  },
}));

const AuthenticationInputLabel = styled(InputLabel)(({ theme }) => ({
  marginLeft: '46px',
  marginTop: '37px',
  color: '#FFFFFF',
  fontFamily: 'Raleway',
  fontSize: '16px',
  lineHeight: '16px',

  [theme.breakpoints.down('md')]: {
    marginLeft: '40px',
    marginTop: '25px',
    marginBottom: '37px',
    fontSize: '16px',
    lineHeight: '16px',
  },

  [theme.breakpoints.down('400')]: {
    marginLeft: '40px',
    marginTop: '20px',
    marginBottom: '2px',
    fontSize: '16px',
    lineHeight: '16px',
  },

  [theme.breakpoints.down('350')]: {
    marginTop: '18px',
    marginLeft: '30px',
    fontSize: '14px',
    lineHeight: '14px',
  },
}));

const AuthenticationBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '306px',
  height: '40px',
  marginTop: '50px',
  marginLeft: '46px',
  [theme.breakpoints.down('md')]: {
    marginLeft: '35px',
    marginTop: '40px',
  },

  [theme.breakpoints.down('400')]: {
    width: '280px',
    height: '40px',
    marginTop: '30px',
    marginLeft: '35px',
  },

  [theme.breakpoints.down('350')]: {
    width: '230px',
    height: '27px',
    marginTop: '25px',
    marginLeft: '30px',
  },
}));

const AuthenticationInput = styled(InputBase)(({ theme }) => ({
  background: '#FFFFFF',
  border: '2px solid #AA9178',
  borderRadius: '5px',

  [theme.breakpoints.down('md')]: {
    width: '100%',
  },

  [theme.breakpoints.down('400')]: {
    width: '100%',
  },

  [theme.breakpoints.down('350')]: {
    width: '100%',
  },
}));

const TickBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '310px',
  height: '30px',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '14px',
  marginLeft: '58px',

  [theme.breakpoints.down('md')]: {
    width: '310px',
    height: '30px',
    marginLeft: '45px',
  },

  [theme.breakpoints.down('400')]: {
    width: '270px',
    height: '30px',
    marginLeft: '45px',
  },

  [theme.breakpoints.down('350')]: {
    width: '220px',
    height: '15px',
    marginLeft: '40px',
  },
}));

const RememberMeCheckbox = withStyles({
  root: {
    '& .MuiSvgIcon-root': {
      fill: 'transparent',
      borderRadius: '0',
      backgroundColor: '#FFFFFF',
      border: '1px solid #999999',
      width: '14px',
      height: '14px',
      marginLeft: '-6px',
    },
    '&$checked': {
      '& .MuiSvgIcon-root': {
        fill: 'black',
        borderRadius: '0',
        backgroundColor: 'white',
        width: '14px',
        height: '14px',
        marginLeft: '-6px',
        border: 'transparent',
      },
    },
  },
  checked: {},
})(Checkbox);

const ForgetPasswordButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontFamily: 'Raleway',
  fontSize: '12px',
  lineHeight: '16px',
  color: 'rgba(255, 255, 255, 0.7)',
  backgroundColor: 'transparent',

  [theme.breakpoints.down('350')]: {
    fontSize: '10px',
    lineHeight: '12px',
  },
}));

const LoginButton = styled(Button)(({ theme }) => ({
  width: '65px',
  height: '26px',
  textTransform: 'none',
  fontFamily: 'Fjalla One',
  fontSize: '14px',
  lineHeight: '18px',
  color: '#FFFFFF',
  backgroundColor: '#AA9178',
  borderRadius: '0',
  marginLeft: '46px',
  marginTop: '26px',

  [theme.breakpoints.down('md')]: {
    marginLeft: '35px',
    marginTop: '26px',
  },

  [theme.breakpoints.down('400')]: {
    marginLeft: '35px',
    marginTop: '26px',
  },

  [theme.breakpoints.down('350')]: {
    marginLeft: '30px',
    marginTop: '20px',
    height: '24px',
    fontSize: '13px',
    width: '65px',
  },
}));

const LTypography = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: 'rgba(255, 255, 255, 0.7)',
  fontFamily: 'Raleway',
  marginLeft: '9px',

  [theme.breakpoints.down('350')]: {
    fontSize: '10px',
    lineHeight: '12px',
    marginLeft: '3px',
  },
}));

const ErrorFormHelperText = styled(FormHelperText)(({ theme }) => ({
  width: '306px',
  fontFamily: 'Raleway',

  [theme.breakpoints.down('400')]: {
    //
    width: '280px',
  },

  [theme.breakpoints.down('350')]: {
    //
    width: '220px',
  },
}));

const validateSchema = (values) => {
  const errors = {};
  const valid = loginSchema.validate(values, { abortEarly: false });
  if (valid.error) {
    valid.error.details.forEach((err) => {
      errors[err.path.join('')] = err.message;
    });
  }
  return errors;
};

export default function LoginInput(props) {
  const [checked, setChecked] = useState(false);

  const [
    login,
    { data: loginData, isSuccess: isLoginSuccess, isError: isLoginError, error: loginError },
  ] = useLoginMutation();

  const dispatch = useDispatch();
  useEffect(() => {
    if (isLoginSuccess) {
      localStorage.setItem('checked', checked);
      localStorage.setItem('role', loginData.data.role);
      dispatch(setCredentials(loginData.data));
      props.closeAfterLogin();
      props.handleLoginChange(true);
      toast.success(`Hi,${loginData.data.userName}`);
    }
    if (isLoginError) {
      if (loginError.status === 404) {
        toast.error('Email or password not exist');
      } else {
        toast.error('Email or password is wrong');
      }
    }
  }, [isLoginSuccess, isLoginError]);

  const submitForm = async (data) => {
    if (data) {
      await login(data);
    } else {
      toast.error('please fill in all fields!');
    }
  };

  return (
    <SignInInputContainer>
      <RegisterRow>
        <RegisterTypography>Don't have an account?</RegisterTypography>
        <RegisterButton onClick={() => props.handlePageChange('REGISTER')}>Register</RegisterButton>
      </RegisterRow>
      <WelcomeTitle>Welcome to Coffeetopia</WelcomeTitle>
      <WelcomeSubtitle>Sign into your account</WelcomeSubtitle>
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        validate={validateSchema}
        onSubmit={submitForm}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => (
          <form onSubmit={handleSubmit}>
            <FormControl variant="standard" sx={{ width: '100%' }}>
              <AuthenticationInputLabel
                shrink
                sx={{ '&.Mui-focused': { color: '#FFFFFF' } }}
                htmlFor="email"
              >
                Email
              </AuthenticationInputLabel>
              <AuthenticationBox>
                <AuthenticationInput
                  id="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.email && errors.email && (
                  <ErrorFormHelperText error>{errors.email}</ErrorFormHelperText>
                )}
              </AuthenticationBox>
            </FormControl>
            <FormControl variant="standard" sx={{ width: '100%' }}>
              <AuthenticationInputLabel
                shrink
                sx={{ '&.Mui-focused': { color: '#FFFFFF' } }}
                htmlFor="password"
              >
                Password
              </AuthenticationInputLabel>
              <AuthenticationBox>
                <AuthenticationInput
                  id="password"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.password && errors.password && (
                  <ErrorFormHelperText error>{errors.password}</ErrorFormHelperText>
                )}
              </AuthenticationBox>
            </FormControl>
            <TickBox>
              <FormControlLabel
                control={
                  <RememberMeCheckbox
                    checked={checked}
                    onChange={(event) => {
                      setChecked(event.target.checked);
                    }}
                    name="checked"
                  />
                }
                label={<LTypography>Remember Me</LTypography>}
              />
              <ForgetPasswordButton onClick={() => props.handlePageChange('FORGET')}>
                Forget Password?
              </ForgetPasswordButton>
            </TickBox>
            <LoginButton type="submit">Login</LoginButton>
          </form>
        )}
      </Formik>
      <GoogleLoginBtn {...props} />
    </SignInInputContainer>
  );
}
